(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('tooltipUi', tooltipUi);

function tooltipUi() {
    return {
        restrict: 'A',
        scope: {
            tooltipClass: '@'
        },

        link(scope, el, attr) {
            $(el).mouseover(function() {
                $(el).tooltip({
                    items: el[0].tagName,
                    content: attr.tooltipUi,
                    position: { my: 'center top+15', at: 'center bottom' },
                    hide: false,
                    show: false,
                    tooltipClass: scope.tooltipClass
                });
                $(el).tooltip('open');
            });

            scope.$on('$destroy', () => $(el).off());
        }
    };
}
})();
